// test938
(938 && 0);
